// extracted by mini-css-extract-plugin
export default {"border":"ujp2AW0BP1_PYfubLsls","small":"YqrUrOQsj4w_2eMJF1TF","medium":"uqXk1OdM3Agk0_xX_a0G","large":"eSLlzQbbasQ45dVZ58gv"};